<script setup lang="ts">
import { useFeatureFlagStore } from '@/featureFlags/stores/featureFlagStore';
import { computed, onMounted } from 'vue';
import type { FeatureFlag } from '../domain/featureFlag';
import { Checkbox } from 'primevue';

const featureFlagStore = useFeatureFlagStore();
const safeFeatureFlags = computed(() => {
  const flags = featureFlagStore.featureFlags?.featureFlags;
  return Array.isArray(flags) ? flags : [];
});

onMounted(async () => {
  await featureFlagStore.initialize();
});

async function toggleFeatureFlag(flag: FeatureFlag) {
  const booleanValue = Boolean(flag.isEnabled);
  await featureFlagStore.toggle(flag.name, booleanValue);
}
</script>

<template>
  <div>
    <div v-for="flag in safeFeatureFlags" :key="flag.name" class="feature-flag">
      <div class="mt-2">
        <Checkbox v-model="flag.isEnabled" @change="() => toggleFeatureFlag(flag)" class="me-2" size="large" binary />
        <label>{{ flag.name }}</label>
      </div>
    </div>

  </div>
</template>
